import React from "react";
import { useStaticQuery, graphql } from "gatsby";
import Img from "gatsby-image";
import { Parallax } from "react-scroll-parallax";
import Grid from "../../../Grid/Grid";
import Button from "../../../core/Button/Button";
import Blob from "../../../../assets/blobs/blob-1.svg";
import CirclesBlob from "../../../../assets/blobs/circles-blob.svg";
import "./home-hero.scss";

const HomeHero = ({ title }) => {
  const mockup = useStaticQuery(graphql`
    query {
      file(relativePath: { eq: "mockup1.png" }) {
        childImageSharp {
          fluid(maxWidth: 300, quality: 100) {
            ...GatsbyImageSharpFluid_withWebp_tracedSVG
          }
        }
      }
    }
  `);

  return (
    <header className="home-hero">
      <Grid addClass="home-hero__grid">
        {/* <div className="home-hero__container"> */}
        <div className="home-hero__content-wrapper">
          <div className="home-hero__heading-wrapper">
            <span className="home-hero__prefix">A New Platform</span>
            <h1 className="home-hero__heading">{title}</h1>
            <Button externalLink="https://askthestar.com/reg" ripple>
              Register Now
            </Button>
          </div>
        </div>
        <div className="home-hero__mockup-wrapper">
          {/* <Parallax x={[-150, 150]}> */}
          <div className="home-hero__mockup">
            <Parallax y={["100px", "-100px"]}>
              <Img
                fluid={mockup.file.childImageSharp.fluid}
                loading="eager"
                // className="home-hero__mockup"
                imgStyle={{ userSelect: "none" }}
              />
            </Parallax>
          </div>

          {/* </Parallax> */}
        </div>
        {/* </div> */}
        <CirclesBlob className="home-hero__circles-blob" />
      </Grid>
      <Blob className="home-hero__blob" />
    </header>
  );
};

export default HomeHero;
